/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Doc_Purchase_InvoiceInputs */

const en_case_doc_purchase_invoice = /** @type {(inputs: Case_Doc_Purchase_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vehicle purchase invoice`)
};

const pt_br2_case_doc_purchase_invoice = /** @type {(inputs: Case_Doc_Purchase_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota fiscal de compra do veículo`)
};

/**
* | output |
* | --- |
* | "Vehicle purchase invoice" |
*
* @param {Case_Doc_Purchase_InvoiceInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_doc_purchase_invoice = /** @type {((inputs?: Case_Doc_Purchase_InvoiceInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Doc_Purchase_InvoiceInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_doc_purchase_invoice(inputs)
	return pt_br2_case_doc_purchase_invoice(inputs)
});